import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Toast } from '../../../common/components/atoms';
import { PopupMessage, POPUP_TYPE } from '../../common/PopupMessage';
import { ERROR_MESSAGE } from '../../common/constants.js'

/*
props:
 Display: true or false
*/
class PhraseEditModal extends Component {
    constructor(props) {
        super(props);

        this.refFileInput = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            id: 0,
            subjectID: 0,
            order: 0,
            audio: "",
            audioData: "",
            textEn: "",
            textJp: "",
            check: false,
            audioChange: false,
        }
    }

    set(phrase) {
        this.setState({
            id: phrase.id,
            subjectID: phrase.subjectID,
            order: phrase.order,
            audio: phrase.audio,
            textEn: phrase.textEn,
            textJp: phrase.textJp,
            check: phrase.check,
            audioChange: false,
        });
    }
    setOrder(order) {
        this.setState({
            order: order,
        });
    }
    get() {
        return {
            id: this.state.id,
            subjectID: this.state.subjectID,
            order: this.state.order,
            audio: this.state.audio,
            textEn: this.state.textEn,
            textJp: this.state.textJp,
            check: this.state.check,
        }
    }

    clear(subjectID) {
        this.setState({
            id: "",
            subjectID: subjectID,
            audio: "",
            textEn: "",
            textJp: "",
            check: false,
            audioChange: false,
        });
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onChangeFile = (e) => {
        this.setState({ audio: e.target.files[0].name });
        this.refFileInput.current.click();
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.addEventListener('load', () => {
            this.setState({
                audioData: reader.result,
                audioChange: true,
            });
        });
        this.refFileInput.current.value = "";
    }

    onClickFileUplode = (e) => {
        this.refFileInput.current.click();
    }

    onClickCheck = (e) => {
        if (this.state.check) {
            this.setState({ check: false });
        } else {
            this.setState({ check: true });
        }
    }

    getDisplayDate() {
        const today = new Date();
        let arr = today.toString().split(' ');
        let month = ('00' + (today.getMonth() + 1)).slice(-2);;

        return arr[3] + '-' + month + '-' + arr[2];
    }
    onSuccessSave = (id) => {
        let mode;
        if (this.props.editType === 1) {
            mode = 2;
        } else {
            mode = 1;
        }
        if (this.state.audioChange) {
            this.props.dispatch({
                type: "UploadAudio_Saga",
                id: id,
                subjectID: this.state.subjectID,
                mode: mode,
                name: this.state.audio,
                audio: this.state.audioData,
                onSuccess: this.onSuccessUpload,
                onFailure: this.onFailure,
            });
        } else {
            this.props.dispatch({
                type: "LoadEnd",
                message:
                    PopupMessage({
                        type: POPUP_TYPE.SYS_INFO,
                        message: "教材情報が正常に保存されました"
                    }),
                state: 1,
            });

            this.props.onClickSave(this.props.editType);
        }
    }
    onSuccessUpload = () => {
        this.props.dispatch({
            type: "LoadEnd",
            message:
                PopupMessage({
                    type: POPUP_TYPE.SYS_INFO,
                    message: "教材情報が正常に保存されました"
                }),
            state: 1,
        });

        this.props.onClickSave(this.props.editType);
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickSave = (e) => {
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.props.dispatch({
                type: "LoadStart"
            });
            if (this.props.editType === 1) {
                this.props.dispatch({
                    type: "SetChunk_Saga",
                    chunk: {
                        id: this.state.id,
                        subjectID: this.state.subjectID,
                        textEn: this.state.textEn,
                        textJp: this.state.textJp,
                        check: this.state.check,
                        order: this.state.order,
                    },
                    onSuccess: this.onSuccessSave,
                    onFailure: this.onFailure,
                });
            } else {
                this.props.dispatch({
                    type: "SetVocabulary_Saga",
                    vocabulary: {
                        id: this.state.id,
                        subjectID: this.state.subjectID,
                        textEn: this.state.textEn,
                        textJp: this.state.textJp,
                        check: this.state.check,
                        order: this.state.order,
                    },
                    onSuccess: this.onSuccessSave,
                    onFailure: this.onFailure,
                });
            }
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if (message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0, [
                syserrMessage,
            ]);
        }
    }

    render() {
        let title = "";
        if (this.props.editType === 1) {
            title = "チャンク";
        } else {
            title = "ボキャブラリー";
        }
        const propsToast = {
            timeout: 2000,
            bottom: "55px",
            right: "20px",
        };
        return (
            <Body name="phrase-edit" Display={this.props.display}>
                <Back Display={this.props.display}></Back>
                <Dialog Display={this.props.display}>
                    <ContentsWrap>
                        <Contents>
                            <Header>{title + "の追加・編集"}</Header>
                            <Column>
                                <Title>
                                    音声ファイル
                                </Title>
                                <Edit>
                                    <input ref={this.refFileInput} type="file" style={{ width: 0, padding: 0, visibility: "hidden" }} onChange={this.onChangeFile} />
                                    <FileButton onClick={this.onClickFileUplode}>アップロード</FileButton>
                                    {this.state.audio}
                                </Edit>
                            </Column>
                            <Column>
                                <Title>
                                    英語
                                </Title>
                                <Edit>
                                    <input style={{ width: "450px" }} name="textEn" value={this.state.textEn}
                                        onChange={this.onChange} />
                                </Edit>
                            </Column>
                            <Column>
                                <Title>
                                    日本語
                                </Title>
                                <Edit>
                                    <input style={{ width: "450px" }} name="textJp" value={this.state.textJp}
                                        onChange={this.onChange} />
                                </Edit>
                            </Column>
                            <Check>
                                <Title>
                                    最終チェック
                                </Title>
                                <CheckButton Check={this.state.check} onClick={this.onClickCheck}>
                                    <i className="fas fa-check" />
                                </CheckButton>
                            </Check>
                        </Contents>
                    </ContentsWrap>
                    <Controls>
                        <Button
                            Color="#0077FF"
                            Width="100px"
                            onClick={this.onClickSave}
                            icon={(<i className="fas fa-file-download" />)}
                            text="保存" />
                        <Button
                            Color="#888888"
                            Width="100px"
                            onClick={this.props.onClickCancel}
                            text="キャンセル" />
                    </Controls>
                </Dialog>
                <Toast ref={this.refToast} {...propsToast} />
            </Body>
        );
    }
}

export { PhraseEditModal };

const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: ${props => (props.Display ? '50%' : '47%')};
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: center;
    transition-duration: 0.2s;
    border-radius: 5px;
    z-index: 2;
`;

const ContentsWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 14px;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
`;

const Header = styled.div`
    color: #888;
    font-size: 18px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    font-weight: bold;
`;

const Column = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 2px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;
const Edit = styled.div`
    min-width: 150px;
    min-height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #888;
    margin-right: 10px;
    max-width: 490px;
    width: 490px;

    input {
        border-radius: 0;
        border: none;
        color: #888;
    }
`;

const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;
const FileButton = styled.div`
    background-color: #efefef;
    color: #888;
    padding: 2px 10px;
    cursor: pointer;
    margin-right: 10px;
`;

const Check = styled.div`
    position: absolute;
    top: 32px;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const CheckButton = styled.div`
    font-size: 32px;
    width: 80px;
    color: ${props => props.Check ? "#26CFA9" : "#dddddd"};
    transition-duration: 0.2s;
    cursor: pointer;
`;
